"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _core = require("@material-ui/core");
var _theme = require("../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var zIndex = _ref.zIndex,
    primary = _ref.palette.primary;
  return {
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      color: (0, _core.fade)(primary.main, 0.5)
    },
    overlay: {
      position: 'absolute',
      width: '100%',
      zIndex: zIndex.mobileStepper,
      backgroundColor: 'rgba(255, 255, 255, 0.7)'
    }
  };
}, {
  name: 'Loader'
});
exports.useStyles = useStyles;